export default __webpack_public_path__ + "static/media/get-started-icon.e4725c40.svg";